export default class Embed {
  constructor({ banners, excludedServices, id, name, logo, shop }) {
    this.banners = banners;
    this.excludedServices = excludedServices;
    this.id = id;
    this.name = name;
    this.logo = logo;
    this.shop = shop;
  }

  static format(embed) {
    return {
      banners: embed.banners,
      excludedServices: embed.excluded_services,
      id: embed.id,
      logo: embed.logo,
      name: embed.name,
      shop: embed.shop_id,
    }
  }
}